import React from 'react'

interface WelcomeProps {
  onExampleClick: (example: string) => void
}

const EXAMPLES = [
  "What's the recipe for soho buns?",
  'What are the terms of our loyalty program?',
  'What is our sick leave policy?',
  'Please draft a response to this email',
  // 'Build a basic FastAPI app',
  // "My GAIL's password is not working",
]

const Welcome: React.FC<WelcomeProps> = ({ onExampleClick }) => {
  return (
    <div className="chat-page__welcome">
      <h2 className="chat-page__welcome-title">How can I help you today?</h2>
      <p className="chat-page__welcome-subtitle">
        I'm BreadGPT, an AI assistant trained on GAIL's internal knowledge base.
      </p>

      <div className="chat-page__welcome-examples">
        {EXAMPLES.map((example, index) => (
          <div
            key={index}
            className="chat-page__welcome-example"
            onClick={() => onExampleClick(example)}
          >
            {example}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Welcome
